import React from 'react';
import './footer.css';
import logo from '../../assets/logo.svg';

const Footer = () => {
    return (
        <div className="gpt3__footer section__padding" id="footer">
            <div className="gpt3__footer-heading">
                <h2 className="gradient__text">Do you want to step into the future before others?</h2>
            </div>
            <div className="gpt3__footer-btn">
                <p>Request Early Access</p>
            </div>

            <div className="gpt3__footer-links">
                <div className="gpt3__footer-links_logo">
                    <img src={logo} alt="logo" />
                    <p>Crechterwoord K12 182 DK Alknjkcb, All Rights Reserved</p>
                </div>
                <div className="gpt3__footer-links_div">
                    <h4>Links</h4>
                    <p>Corporate</p>
                    <p>Social Media</p>
                    <p>Counters</p>
                    <p>Contact</p>
                </div>
                <div className="gpt3__footer-links_div">
                    <h4>Company</h4>
                    <p>Terms and conditions</p>
                    <p>Privacy policy</p>
                    <p>Contact</p>
                </div>
                <div className="gpt3__footer-links_div">
                    <h4>Get in touch</h4>
                  <p>Crechterwoord K12 182 DK Alknjkcb</p>
                  <p>085-132567</p>
                  <p>a.muse@rapidmuse.com</p>
                </div>
            </div>
            <div className="gpt3__footer-copyright">
                <p>© 2021 TopLine Ai. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Footer
